__turbopack_context__.v({
  "ButtonWrapper": "LoyaltyCustomerModalForm-module-scss-module__WljmMG__ButtonWrapper",
  "Form": "LoyaltyCustomerModalForm-module-scss-module__WljmMG__Form",
  "PrimaryButton": "LoyaltyCustomerModalForm-module-scss-module__WljmMG__PrimaryButton",
  "SecondaryButton": "LoyaltyCustomerModalForm-module-scss-module__WljmMG__SecondaryButton",
});
